import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import { LocationLinkCSV, LocationType } from 'domain/entity/location';
import readCSVLocationLinksClient from 'use-case/link/read/readCSVLocationLinksClient';
import readCSVLocationLinksCriteria from 'use-case/link/read/readCSVLocationLinksCriteria';

const readCSVLocationLinksApiClient = (httpClient: httpClientFunction, baseUrl: string): readCSVLocationLinksClient => (
    criteria: readCSVLocationLinksCriteria
) =>
    httpClient(
        `${baseUrl}/dashboards/dashboards/${criteria.dashboardId}/links/${criteria.linkId}/locations?start=${criteria.start}&size=${criteria.size}`,
        {}
    )
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then(asLocation)
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));

const asLocation = (locationsLinkJson: LocationLinkJson[]) =>
    locationsLinkJson.map(
        (locationLinkJson: LocationLinkJson) =>
            new LocationLinkCSV(locationLinkJson.name, locationLinkJson.linked_url, locationLinkJson.type as LocationType)
    );

export type LocationLinkJson = {
    name: string;
    ['linked_url']: string;
    type: string;
};

export default readCSVLocationLinksApiClient;
